/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetJsonWebKeySetDeletePreflightSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetJsonWebKeySetDeletePreflightRequest = {
  /**
   * The ID of the key set to summarize.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetJsonWebKeySetDeletePreflightSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetJsonWebKeySetDeletePreflightSecurity$outboundSchema:
  z.ZodMiniType<
    GetJsonWebKeySetDeletePreflightSecurity$Outbound,
    GetJsonWebKeySetDeletePreflightSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getJsonWebKeySetDeletePreflightSecurityToJSON(
  getJsonWebKeySetDeletePreflightSecurity:
    GetJsonWebKeySetDeletePreflightSecurity,
): string {
  return JSON.stringify(
    GetJsonWebKeySetDeletePreflightSecurity$outboundSchema.parse(
      getJsonWebKeySetDeletePreflightSecurity,
    ),
  );
}

/** @internal */
export type GetJsonWebKeySetDeletePreflightRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetJsonWebKeySetDeletePreflightRequest$outboundSchema:
  z.ZodMiniType<
    GetJsonWebKeySetDeletePreflightRequest$Outbound,
    GetJsonWebKeySetDeletePreflightRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function getJsonWebKeySetDeletePreflightRequestToJSON(
  getJsonWebKeySetDeletePreflightRequest:
    GetJsonWebKeySetDeletePreflightRequest,
): string {
  return JSON.stringify(
    GetJsonWebKeySetDeletePreflightRequest$outboundSchema.parse(
      getJsonWebKeySetDeletePreflightRequest,
    ),
  );
}
